<div id="externalUserDashboard" class="dataStandard" *ngIf="!showIssueSummary && !showIssueSummaryPreview">
  <fm-loading-spinner [isLoading]="isLoadingDueDiligence"></fm-loading-spinner>
  <fm-notice [notice]="notice"></fm-notice>
  <fm-alert-feedback [alignLeft]="false" [alert]="alertFeedback"></fm-alert-feedback>

  <fm-sidebar-container>

    <fm-sidebar [(opened)]="openedSidebar" position="right" mode="over" [animated]="true" [width]="sideBarWidth"
      [autoCollapseWidth]="sideBarWidth" [height]="sideBarHeight" [autoCollapseHeight]="sideBarHeight"
      [style]="sidebarStyle" [autoCollapseOnInit]="true" [closeOnClickOutside]="false" [closeOnClickBackdrop]="false">

      <div class="sidebar" *ngIf="showSideBarFilter == true">
        <app-acquisitions-filter [acqnFiltersDetails]="acqnFiltersDetails" (closeSidebar)="onClickCloseSidebar()"
          (applyAcqnFilters)="onApplyAcqnFilters($event)"></app-acquisitions-filter>
      </div>

      <div class="sidebar" *ngIf="showSideBarAcquisitionPropertyDetails == true">
        <app-acquisition-property-details 
          [disableUpload] = "disableUpload"
          (closeSidebar)="onClickCloseSidebar()"
          (propertyFileUploadDetailsFromSidebar)="onGetPropertyFileUploadDetailsFromSidebar($event)"></app-acquisition-property-details>
      </div>
    </fm-sidebar>

    <div fm-sidebar-content>
      <br>

      <app-user-notification *ngIf="showSystemNotification" [title]="systemNotificationFlagValue.title"
        [message]="systemNotificationFlagValue.message">
      </app-user-notification>
      <br>

      <app-header-title [lenderName]="lenderName"
        [sellerServicerNumber]="sellerServicerNumber.sellerServicerNo"></app-header-title>

      <!-- <div id="userInformationTable" class="userInformationTable">
    <fm-table [columns]="cols1" [value]="userInfoArray">
      <ng-template fmTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns">{{col.header}}</th>
        </tr>
      </ng-template>
      <ng-template fmTemplate="body" let-rowData let-columns="columns">
        <tr align="center">
          <td *ngFor="let col of columns">
            {{rowData[col.field]}}
          </td>
        </tr>
      </ng-template>
    </fm-table>
  </div> -->

      <!-- TODO: Need to test with docway launch point -->
      <!-- <div *ngIf="docWayDetailsService.hasDealId">
    <br>
  </div>

  <div id="docwayDetailsTable" class="docwayDetailsTable" *ngIf="docWayDetailsService.hasDealId">
    <fm-table [columns]="cols2" [value]="docWayDetailsService.docwayDetailsArray">
      <ng-template fmTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns">{{col.header}}</th>
        </tr>
      </ng-template>
      <ng-template fmTemplate="body" let-rowData let-columns="columns">
        <tr align="center">
          <td *ngFor="let col of columns">
            {{rowData[col.field]}}
          </td>
        </tr>
      </ng-template>
    </fm-table>
  </div> -->

      <br>
      <br>


      <div class="main-content">

        <!-- Show Action Required | Acquisitions | Data Files tabs -->
        <div style="padding-left: 50px; padding-right: 50px;">
          <fm-tabMenu [model]="tab_menu_items" [activeItem]="this.tab_menu_items[this.active_menu_item_number]"
            (tabChanged)="loadTabData($event)"></fm-tabMenu>

          <div *ngIf="active_menu_item == 'Action Required'">
            <app-action-required [lenderActionRequired]='this.lenderActionRequired.acqnDashboardDetails'
              [isAdminUser]="this.isAdminUser" [isInternal]="this.isInternal" [isAssetManager]="this.isAssetManager"
              [isMFOpsUser]="this.isMFOpsUser" [isMAUser]="this.isMAUser"
              (propertyFileUploadDetails)="onGetPropertyFileUploadDetails($event)"></app-action-required>
          </div>

          <div *ngIf="active_menu_item == 'Lender Ranking'">
            <app-lender-ranking [acqnDetails]='acqnDetails' [selectStartPeriod]="selectStartPeriod"
              [selectedStartPeriod]="selectedStartPeriod" [selectEndPeriod]="selectEndPeriod"
              [selectedEndPeriod]="selectedEndPeriod" [isInternal]="isInternal"
              (refreshAcqnDetails)="onRefreshAcqnDetails($event)" (getEndPeriodDates)="onGetEndPeriodDates($event)"
              (openAcqnFilterSidebar)="onOpenAcqnFilterSidebar()">
            </app-lender-ranking>
          </div>

          <div *ngIf="active_menu_item == 'Acquisitions'">
            <app-acquisitions [acqnDetails]='acqnDetails' [selectStartPeriod]="selectStartPeriod"
              [selectedStartPeriod]="selectedStartPeriod" [selectEndPeriod]="selectEndPeriod"
              [selectedEndPeriod]="selectedEndPeriod" [isInternal]="isInternal"
              [showAcqnTableEditCheckbox]="showAcqnTableEditCheckbox"
              (refreshAcqnDetails)="onRefreshAcqnDetails($event)"
              (getEndPeriodDates)="onGetEndPeriodDates($event)" (openAcqnFilterSidebar)="onOpenAcqnFilterSidebar()"
              (openAcqnPropertyDetailsSidebar)="onOpenAcqnPropertyDetailsSidebar()"
              (selectedPropertyDetails)="onGetSelectedPropertyDetails($event)"
              (propertyFileUploadPCADetails)="onFileUploadDetailsPCA($event)"
              [showUploadFiles]="showUploadFiles"></app-acquisitions>
          </div>

          <div *ngIf="active_menu_item == 'Data Files'">
            <div id="data_files_title_header">
              <span id="dataFilesTitle">Data Files</span>
              <span id="count_data_files_list_badge">{{countDataFilesList}}</span>
          </div>

            <div class="subtitle" *ngIf="isAssetManager != true">
              <i>{{tableSubtitle}}</i>
            </div>

            <div id="submittedFilesTable" class="submittedFilesTable">
              <fm-table #dftbl [columns]="!isMAUser ? cols3 : cols3_bpo" [value]="dataFilesDetailsDashboardDisplay" (onFilter)="onfilteredDataFilesData(dftbl)"
                sortMode="single" [loadingIcon]="true" [paginator]="true" [rows]="30"
                [rowsPerPageOptions]="[25,30,50,75,100,125,150,200]" [enableTableEntryTotal]="true" tableEntryTotalPosition="bottomLeft" paginatorPosition="bottomRight" >
                <ng-template fmTemplate="caption">
                  <div style="text-align: left; float:left;">
                    <input placeholder="Search" style="width:auto; float:right; margin-bottom: 10px;" fmTextInput type="text"
                      [(ngModel)]="dataFilesFilterBinding"
                      (input)="dftbl.filterGlobal($event.target.value, 'contains')" />
                  </div>
                  <div id="dataFilesSummaryNew" *ngIf="isInternal == true && isAssetManager != true && isMAUser != true">
                    <button style="float: right; margin-right: 0px; margin-top: 0px; margin-bottom: 10px; width: 200px;" fmButton type="button" [primary]="true" fmButton
                      (click)="showDataFilesFilterSidebar($event)" label="Filter"></button>
                  </div>
                </ng-template>
                <ng-template fmTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [fmSortableColumn]="col.field" [style.width]="col.width">
                      {{col.header}}
                      <fm-sortIcon [field]="col.field"></fm-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template fmTemplate="body" let-rowData let-columns="columns">
                  <tr align="center">
                    <td *ngFor="let col of columns">
                      <p *ngIf="col.field != 'submitDT'">{{rowData[col.field]}}</p>
                      <p *ngIf="col.field == 'submitDT'">{{rowData[col.field] | date:'MM/dd/yyyy H:mm:ss'}}</p>
                    </td>
                  </tr>
                </ng-template>
              </fm-table>
              <div id="noFilesSubmitted" align="left" *ngIf="dataFilesDetailsDashboardDisplay.length === 0">
                <br>
                <i>{{tableNoSubmittedFilesMessage}}</i><a [routerLink]="[]" *ngIf="!disableUpload"><u>Upload data
                    files.</u></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fm-sidebar-container>

  <br>
</div>

<div id="issueSummaryPreviewPage" *ngIf="showIssueSummaryPreview">
  <app-issue-summary-preview></app-issue-summary-preview>
</div>